<template>
  <v-container grid-list-md class="text-center">
    <h1>NOSOTROS</h1>
    <div
      style="width: 6%; height: 3px;margin: 10px auto;background:#0D47A1;border-bottom: 1px solid black;"
    ></div>
    <v-layout row wrap>
      <v-flex light xs12 md4>
        <v-layout row wrap>
          <v-flex
            v-for="(section, index) in sections"
            :key="index"
            class="ma-0 pa-0"
            xs12
          >
            <v-btn
              @click="$vuetify.goTo('#' + section.selector)"
              color="primary"
              text
              >{{ section.title }}</v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-if="firstSection" xs12 md8>
        <v-card-text>
          <h1 :id="firstSection.selector" class="headline mb-0">
            {{ firstSection.title }}
          </h1>
        </v-card-text>
        <v-card-text
          v-for="(paragraph, index) in firstSection.paragraphs"
          :key="index"
        >
          <p class="subheading">{{ paragraph.content }}</p>
        </v-card-text>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <GmapMap
          :center="{ lat: 19.3785872, lng: -69.863065 }"
          :zoom="12"
          map-type-id="roadmap"
          style="width: 100%; height: 400px"
        >
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="true"
            :draggable="true"
            @click="center = m.position"
          />
        </GmapMap>
      </v-flex>
    </v-layout>
    <v-layout
      v-for="(section, index) in remainingSections"
      :key="index"
      row
      wrap
    >
      <v-flex light xs12 md4>
        <v-card-text>
          <h1 :id="section.selector" class="headline mb-0">
            {{ section.title }}
          </h1>
        </v-card-text>
      </v-flex>
      <v-flex xs12 md8>
        <v-flex dark>
          <v-card-text
            v-for="(paragraph, pIndex) in section.paragraphs"
            :key="pIndex"
          >
            <h3 v-if="paragraph.title" class="font-weight-bold subheading">
              {{ paragraph.title }}
            </h3>
            <p class="subheading">{{ paragraph.content }}</p>
          </v-card-text>
        </v-flex>
      </v-flex>
    </v-layout>
    <subscribe-container></subscribe-container>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";

import SubscribeContainer from "../../components/shared/Subscribe-Container";

export default {
  name: "About",
  components: {
    SubscribeContainer,
  },
  data: () => ({
    markers: [
      {
        title: "NAGUA",
        position: {
          lat: 19.3782268,
          lng: -69.8526621,
        },
        description: "Sucursal Nagua",
      },
      {
        title: "EL FACTOR",
        position: {
          lat: 19.3158207,
          lng: -69.8949767,
        },
        description: "Sucursal El Factor",
      },
      {
        title: "MATANCITAS",
        position: {
          lat: 19.3540834,
          lng: -69.8345005,
        },
        description: "Sucursal Matancitas",
      },
    ],
  }),
  created() {
    this.loadAboutSections();
  },
  computed: {
    firstSection() {
      return this.sections ? this.sections[0] : null;
    },
    remainingSections() {
      const remaining = this.sections ? this.sections.slice(1) : null;
      return remaining;
    },
    ...mapState({
      sections: (state) => state.about.sections,
    }),
  },
  methods: mapActions(["loadAboutSections"]),
};
</script>

<style>
.rounded-card {
  border-radius: 6px;
}
</style>
